const EditorToolbar = ( {editor} ) => {

	return (
		<div className="toolbar">
		<button
			onClick={() => editor.chain().focus().toggleBold().run()}
			disabled={
				!editor.can()
				.chain()
				.focus()
				.toggleBold()
				.run()
			}
			className={editor.isActive('bold') ? 'is-active' : ''}
			aria-label={window?.t?.BOLD}
		>
			<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="svg-icon" overflow="hidden" viewBox="0 0 1024 1024"><path d="M733.61 467.71a267.56 267.56 0 0 0-185.6-457.13H183.47a53.33 53.33 0 0 0 0 106.67h43.22a10.67 10.67 0 0 1 10.66 10.66V896a10.67 10.67 0 0 1-10.66 10.67h-43.22a53.33 53.33 0 1 0 0 106.66h425.08A287.66 287.66 0 0 0 733.57 467.8zm-185.6-350.46a160.51 160.51 0 0 1 0 320.98H354.7a10.67 10.67 0 0 1-10.67-10.67V128a10.67 10.67 0 0 1 10.67-10.67zm60.59 789.33H354.69a10.67 10.67 0 0 1-10.67-10.67V555.56a10.67 10.67 0 0 1 10.67-10.66h253.9a180.86 180.86 0 0 1 0 361.68z"/></svg>
		</button>
		<button
			onClick={() => editor.chain().focus().toggleItalic().run()}
			disabled={
				!editor.can()
				.chain()
				.focus()
				.toggleItalic()
				.run()
			}
			className={editor.isActive('italic') ? 'is-active' : ''}
			aria-label={window?.t?.ITALIC}
		>
			<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="svg-icon" overflow="hidden" viewBox="0 0 1024 1024"><path d="M960 10.58H634.15a53.33 53.33 0 0 0 0 106.67h46.34a10.67 10.67 0 0 1 9 16.38l-485.54 763.1a21.33 21.33 0 0 1-18 9.85H64a53.33 53.33 0 0 0 0 106.67h325.85a53.33 53.33 0 0 0 0-106.67H343.5a10.67 10.67 0 0 1-9-16.38l485.54-763.05a21.33 21.33 0 0 1 18-9.9H960a53.33 53.33 0 0 0 0-106.67z"/></svg>
		</button>
		<button
			onClick={() => editor.chain().focus().toggleStrike().run()}
			disabled={
				!editor.can()
				.chain()
				.focus()
				.toggleStrike()
				.run()
			}
			className={editor.isActive('strike') ? 'is-active' : ''}
			aria-label={window?.t?.STRIKE}
		>
			<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="svg-icon" overflow="hidden" viewBox="0 0 1024 1024"><path d="M1013.33 552.62A53.33 53.33 0 0 0 960 499.2H578.73a21 21 0 0 1-12.03-3.84c-30.8-21.89-63.23-41.86-94.64-61.1-119.46-73.17-192-123.73-192-207.49 0-95.36 94.17-109.6 150.32-109.6a193.7 193.7 0 0 1 131.45 32.59 113.58 113.58 0 0 1 19.08 84.9v12.8a53.33 53.33 0 1 0 106.66 0v-11.43a208.51 208.51 0 0 0-49.7-161.15c-42.71-43.26-110.55-64.3-207.32-64.3-156.08 0-256.98 84.87-256.98 216.28 0 118.31 80.72 192.51 170.66 252.88a10.67 10.67 0 0 1-5.93 19.55H64a53.33 53.33 0 0 0 0 106.66h468.35a10.7 10.7 0 0 1 6.79 2.48 185.13 185.13 0 0 1 82.43 147.88c0 139.43-146.18 150.27-191.02 150.27-77.4 0-133.93-17.28-163.58-50.05a144.81 144.81 0 0 1-27.74-115.2 53.33 53.33 0 0 0-106.15-10.5 245.76 245.76 0 0 0 54.65 197.3c51.2 56.49 132.87 85.33 242.7 85.33 178.08 0 297.68-103.25 297.68-256.94a258.52 258.52 0 0 0-36.23-134.27 10.67 10.67 0 0 1 9.22-16.08H960a53.33 53.33 0 0 0 53.33-53.55z"/></svg>
		</button>
		<button
			onClick={() => editor.chain().focus().setParagraph().run()}
			className={editor.isActive('paragraph') ? 'is-active' : ''}
			aria-label={window?.t?.PARAGRAPH}
		>
			<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="svg-icon" overflow="hidden" viewBox="0 0 1024 1024"><path d="M960 10.58H308.4a297.69 297.69 0 1 0 0 595.37h98.9a10.67 10.67 0 0 1 10.66 10.67V960a53.33 53.33 0 0 0 106.67 0V128a10.67 10.67 0 0 1 10.67-10.67h157.1A10.67 10.67 0 0 1 703.05 128v832a53.33 53.33 0 0 0 106.67 0V128a10.62 10.62 0 0 1 10.66-10.67H960a53.33 53.33 0 0 0 0-106.66zM418.13 488.62a10.67 10.67 0 0 1-10.66 10.67h-99.08a191.02 191.02 0 1 1 0-382.04h98.9A10.67 10.67 0 0 1 418.14 128z"/></svg>
		</button>
		<button
			onClick={() => editor.chain().focus().toggleHeading({ level: 1 }).run()}
			className={editor.isActive('heading', { level: 1 }) ? 'is-active' : ''}
			aria-label={window?.t?.HEADING + ' 1'}
		>
		H1
		</button>
		<button
			onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
			className={editor.isActive('heading', { level: 2 }) ? 'is-active' : ''}
			aria-label={window?.t?.HEADING + ' 2'}
		>
		H2
		</button>
		<button
			onClick={() => editor.chain().focus().toggleHeading({ level: 3 }).run()}
			className={editor.isActive('heading', { level: 3 }) ? 'is-active' : ''}
			aria-label={window?.t?.HEADING + ' 3'}
		>
		H3
		</button>
		<button
			onClick={() => editor.chain().focus().toggleHeading({ level: 4 }).run()}
			className={editor.isActive('heading', { level: 4 }) ? 'is-active' : ''}
			aria-label={window?.t?.HEADING + ' 4'}
		>
		H4
		</button>
		<button
			onClick={() => editor.chain().focus().toggleHeading({ level: 5 }).run()}
			className={editor.isActive('heading', { level: 5 }) ? 'is-active' : ''}
			aria-label={window?.t?.HEADING + ' 5'}
		>
		H5
		</button>
		<button
			onClick={() => editor.chain().focus().toggleHeading({ level: 6 }).run()}
			className={editor.isActive('heading', { level: 6 }) ? 'is-active' : ''}
			aria-label={window?.t?.HEADING + ' 6'}
		>
		H6
		</button>
        <button
			onClick={() => editor.chain().focus().toggleBulletList().run()}
			className={editor.isActive('bulletList') ? 'is-active' : ''}
			aria-label={window?.t?.UNORDERED_LIST}
        >
          	<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="svg-icon" overflow="hidden" viewBox="0 0 1024 1024"><path d="M0 170.58a106.67 106.67 0 1 0 213.33 0 106.67 106.67 0 1 0-213.33 0ZM362.67 213.33h618.66a42.67 42.67 0 0 0 0-85.33H362.67a42.67 42.67 0 0 0 0 85.33zM0 511.91a106.67 106.67 0 1 0 213.33 0 106.67 106.67 0 1 0-213.33 0ZM981.33 469.33H362.67a42.67 42.67 0 0 0 0 85.34h618.66a42.67 42.67 0 0 0 0-85.34zM0 853.25a106.67 106.67 0 1 0 213.33 0 106.67 106.67 0 1 0-213.33 0ZM981.33 810.67H362.67a42.67 42.67 0 0 0 0 85.33h618.66a42.67 42.67 0 0 0 0-85.33z"/></svg>
        </button>
        <button
			onClick={() => editor.chain().focus().toggleOrderedList().run()}
			className={editor.isActive('orderedList') ? 'is-active' : ''}
			aria-label={window?.t?.ORDERED_LIST}
        >
          	<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="svg-icon" overflow="hidden" viewBox="0 0 1024 1024"><path d="M330.67 192h640a42.67 42.67 0 0 0 0-85.33h-640a42.67 42.67 0 0 0 0 85.33zm640 277.33h-640a42.67 42.67 0 1 0 0 85.34h640a42.67 42.67 0 0 0 0-85.34zm0 362.67h-640a42.67 42.67 0 0 0 0 85.33h640a42.67 42.67 0 0 0 0-85.33zm-876.3-96.09a85.33 85.33 0 0 0-82.47 63.32 32 32 0 1 0 61.87 16.47 21.33 21.33 0 1 1 20.6 26.88 32 32 0 1 0 0 64 21.33 21.33 0 1 1-20.56 27.1 32 32 0 1 0-61.65 17.06 85.33 85.33 0 1 0 153.13-70.31 10.7 10.7 0 0 1 0-11.86 85.33 85.33 0 0 0-70.91-132.74zm86.96-277.33a85.33 85.33 0 0 0-170.66 0 32 32 0 0 0 64 0 21.33 21.33 0 0 1 42.66 0 43.99 43.99 0 0 1-9.68 27.52L17.66 598.57a32 32 0 0 0 25 52.01h106.67a32 32 0 0 0 0-64h-17.87a10.62 10.62 0 0 1-8.32-17.32l34.73-43.18a108.54 108.54 0 0 0 23.46-67.5zm-10.66-234.67H160a10.67 10.67 0 0 1-10.67-10.58V69.25a58.75 58.75 0 0 0-58.66-58.67H64a32 32 0 0 0 0 64h10.67a10.67 10.67 0 0 1 10.66 10.75v128A10.67 10.67 0 0 1 74.67 224H64a32 32 0 0 0 0 64h106.67a32 32 0 0 0 0-64z"/></svg>
        </button>
        <button
			onClick={() => editor.chain().focus().toggleLink({href: window.prompt('URL') }).run()}
			className={editor.isActive('link') ? 'is-active' : ''}
			aria-label={window?.t?.LINK}
        >
			<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="svg-icon" overflow="hidden" viewBox="0 0 32 32"><path d="M23.46 12.38a1.25 1.25 0 0 0 0 2.5 4.47 4.47 0 0 1 0 8.94H17.1a4.47 4.47 0 0 1 0-8.94 1.25 1.25 0 0 0 0-2.5 6.97 6.97 0 1 0 0 13.94h6.37a6.97 6.97 0 1 0 0-13.94h-.01zM8.53 17.31a4.46 4.46 0 1 1 0-8.92h6.35a4.46 4.46 0 0 1 0 8.92 1.25 1.25 0 0 0 0 2.5 6.96 6.96 0 0 0 0-13.92H8.53a6.96 6.96 0 0 0 0 13.92 1.25 1.25 0 0 0 0-2.5z"/></svg>
        </button>
		</div>
	)

}

export default EditorToolbar;